import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=2a33496e&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&lang=ts&"
export * from "./ProductItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=2a33496e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33496e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a33496e')) {
      api.createRecord('2a33496e', component.options)
    } else {
      api.reload('2a33496e', component.options)
    }
    module.hot.accept("./ProductItem.vue?vue&type=template&id=2a33496e&scoped=true&", function () {
      api.rerender('2a33496e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ProductItem.vue"
export default component.exports